webpackJsonp([70144966829960],{

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(18);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Contact = function Contact() {
	  return Glamor.createElement(
	    'div',
	    null,
	    Glamor.createElement(
	      'div',
	      { className: 'row' },
	      Glamor.createElement(
	        'h2',
	        null,
	        'Contact Details'
	      ),
	      Glamor.createElement(
	        'div',
	        {
	          className: 'columns six center',
	          style: {
	            lineHeight: 1.5
	          }
	        },
	        Glamor.createElement(
	          'p',
	          { 'class': 'address' },
	          Glamor.createElement(
	            'span',
	            null,
	            'Nicholas Pappas'
	          ),
	          Glamor.createElement('br', null),
	          Glamor.createElement(
	            'span',
	            null,
	            'Los Angeles, CA'
	          ),
	          Glamor.createElement('br', null),
	          Glamor.createElement(
	            'span',
	            null,
	            Glamor.createElement(
	              'a',
	              { href: 'mailto:nickhtpappas@gmail.com' },
	              'nickhtpappas@gmail.com'
	            )
	          )
	        )
	      ),
	      Glamor.createElement(
	        'div',
	        { className: 'columns six center' },
	        Glamor.createElement(
	          'h4',
	          null,
	          'Social Media Profiles'
	        ),
	        Glamor.createElement(
	          'ul',
	          { className: 'social-links' },
	          Glamor.createElement(
	            'li',
	            null,
	            Glamor.createElement(
	              'a',
	              { href: 'https://www.linkedin.com/in/nicholas-pappas-044189130/' },
	              Glamor.createElement('i', { className: 'fa fa-linkedin' })
	            )
	          ),
	          Glamor.createElement(
	            'li',
	            null,
	            Glamor.createElement(
	              'a',
	              { href: 'https://github.com/VisionsOfDrifting' },
	              Glamor.createElement('i', { className: 'fa fa-github' })
	            )
	          ),
	          Glamor.createElement(
	            'li',
	            null,
	            Glamor.createElement(
	              'a',
	              { href: 'https://codepen.io/VisionsOfDrifting/#' },
	              Glamor.createElement('i', { className: 'fa fa-codepen' })
	            )
	          ),
	          Glamor.createElement(
	            'li',
	            null,
	            Glamor.createElement(
	              'a',
	              { href: 'https://twitter.com/Dreams_Of_AI' },
	              Glamor.createElement('i', { className: 'fa fa-twitter' })
	            )
	          )
	        )
	      )
	    ),
	    Glamor.createElement(
	      'div',
	      { className: 'row' },
	      Glamor.createElement(
	        'div',
	        { className: 'columns' },
	        Glamor.createElement(
	          'p',
	          {
	            css: {
	              textAlign: 'center',
	              '@media only screen and (max-width: 768px)': {
	                textAlign: 'justify'
	              }
	            }
	          },
	          'If you are interested in hiring me or would like to collaborate on present or future projects contact me. Feel free to send me an email or message me on Linkedin.'
	        )
	      )
	    )
	  );
	};
	
	exports.default = Contact;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-052f3a25e49139c63a8d.js